<div class="login-container">
  <img src="/assets/images/ABS-Icon.png">
  <h3 style="color: #0066cc">Automatic Blood Collection System</h3>
  <mat-card>
    <mat-card-header>
      <mat-card-title> <p style="color: #0066cc; margin: 0">เข้าสู่ระบบ</p></mat-card-title>
    </mat-card-header>
    <form (ngSubmit)="login()" [formGroup]="fg" #form>
      <mat-card-content>
        <mat-divider></mat-divider>
        <br>
          <mat-form-field>
            <input formControlName="email" matInput placeholder="อีเมลล์" name="Email"  required>
            <mat-error *ngIf="fg.get('email').getError('required')">{{ _e.loginRequiredEmail }}</mat-error>
            <mat-error *ngIf="fg.get('email').getError('email')">{{ _e.loginFormatEmail }}</mat-error>
            <mat-error *ngIf="fg.get('email').getError('emailDidNotFound')">{{ _e.authenEmailWrongCred }}</mat-error>
          </mat-form-field>
          <br>
          <mat-form-field>
            <input formControlName="password" matInput placeholder="รหัสผ่าน" type="password" name="password" required>
            <mat-error *ngIf="fg.get('password').getError('required')">{{ _e.loginRequiredPassword }}</mat-error>
          </mat-form-field>
          <br>
          <mat-error *ngIf="authenFailed"> {{ authenFailMessage}} <br></mat-error>
      </mat-card-content>
      <mat-card-actions>
        <mat-checkbox formControlName="rememberMe">จดจำฉัน</mat-checkbox>
        <div class="flex-spacer"></div>
        <button mat-raised-button class="submit-button">เข้าสู่ระบบ</button>
      </mat-card-actions>
      <div class="mat-card-after-actions" ><a class="forgot-btn" (click)="forgotPassword()">ลืมรหัสผ่าน?</a></div>  
    </form>
  </mat-card>
</div>
